import React, { useContext } from 'react'
import SkillPicker from 'Components/reusable/InputFields/SkillPicker'
import { ISkillOrIndustryOrRole } from 'types/cvsInterfaces'
import { SkillId } from 'types/ids'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Person picker.
 */
export const DataEditContextSkillField = <T extends AnyObject>({
  field,
  dataField,
  usedSkills,
  submitOnEnter,
  icon,
  type,
  placeholder,
  hideLabel,
  options,
  insetLabel,
  resetOnSelect,
  ...rest
}: {
  field: EditableFieldsOfType<T, SkillId | null>
  dataField: EditableFieldsOfType<T, ISkillOrIndustryOrRole | null>
  usedSkills?: ISkillOrIndustryOrRole[]
  submitOnEnter?: boolean
  type: string
  icon?: React.ReactElement
  placeholder?: string
  hideLabel?: boolean
  options?: ISkillOrIndustryOrRole[]
  insetLabel?: boolean
  resetOnSelect?: boolean
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, disabled, setFields, localeBase, t, handleSubmit } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: ISkillOrIndustryOrRole | null) => {
    setFields({ [field]: newValue?.id ?? null, [dataField]: newValue })
  }

  const dataValue = flatData[dataField] as unknown as ISkillOrIndustryOrRole

  return (
    <SkillPicker
      onChange={handleChange}
      icon={icon}
      disabled={disabled[field]}
      value={dataValue ?? null}
      label={t(`${localeBase}.${field}`)}
      usedSkills={usedSkills}
      onKeyDown={e => submitOnEnter && handleSubmit(e)}
      type={type}
      placeholderText={placeholder}
      placeholderLabel={hideLabel ? placeholder : undefined}
      options={options}
      insetLabel={insetLabel}
      resetOnSelect={resetOnSelect}
      {...rest}
    />
  )
}

/**
 * Certificate picker.
 */
